import React, { useRef } from 'react';
import { useState } from 'react';
// @ts-ignore
import moment from 'moment';
import Modal from '../../../../Components/Modal/Modal';
import { useTreatmentContext } from '../../../../Services/TreatmentContext';
import { Size } from '../../../../Enums/Size.enum';
import HealthPlanDiagnosticImaging from './HealthPlanDiagnosticImaging';

interface HealthPlanDiagnosticImagingModalProps {
	opened: boolean;
	onClose: any;
	disableSubmit?: boolean;
}

export default function HealthPlanDiagnosticImagingModal(
	props: HealthPlanDiagnosticImagingModalProps,
) {
	const { opened, onClose, disableSubmit } = props;
	const { isCase } = useTreatmentContext();

	return (
		<Modal opened={opened} onClose={onClose} wrapChat={isCase} size={Size.LG}>
			<Modal.Header title={'base.diagnosticImagingOrder'} />
			<Modal.Content contentScroll={true}>
				<HealthPlanDiagnosticImaging
					onSuccess={onClose}
					disableSubmit={disableSubmit}
				/>
			</Modal.Content>
		</Modal>
	);
}
